import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { ActivityOnboarding } from "@/interfaces/onboarding-interfaces/ActivityOnboarding";
import { Onboarding } from "@/interfaces/onboarding-interfaces/Onboarding";
import { UserOnboarding } from "@/interfaces/onboarding-interfaces/UserOnboarding";
import { LazoJobTitle } from "@/types/LazoJobTitle";
import { SuccessfullyOnboarding } from "@/types/SuccessfullyOnboarding";

class OnboardingService {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  async validateCompanyName(companyName: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.get(`${this.path}/validate-company-name/${companyName}`);
  }

  async onboardUserAndCreateCompany(onboarding: Onboarding): Promise<ApiResponseV2<SuccessfullyOnboarding>> {
    return HttpClientV2.post(`${this.path}/onboard-user`, onboarding);
  }

  async answerActivityForm(userExternalId: string, activity: ActivityOnboarding): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/answer-activity-form/${userExternalId}`, activity);
  }

  async updateUserPhone(phone: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/phone`, { phone });
  }

  async verifyPhoneCode(phone: string, code: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/phone/verify-code`, { code, phone });
  }

  async validatePersonalInformation(personalInformation: UserOnboarding): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/validate-personal-information`, personalInformation);
  }

  async resendVerificationEmail(email: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/resend-verification-email/${email}`, {});
  }

  async getExternalJobTitles(): Promise<ApiResponseV2<LazoJobTitle[]>> {
    return HttpClientV2.get(`${this.path}/job-titles`);
  }
}

export default new OnboardingService("/api/onboarding");
